import { Box, Container, useTheme } from "@mui/material";
import { FlightCardSkeleton, IconPathLoader } from "@thekilroygroup/shared-ui";
import { CustomAnimation } from "@thekilroygroup/shared-ui";
import React from "react";

interface IProps {
  title: string;
  teaserText?: string;
}

export const SearchResultsLoader = ({ title, teaserText }: IProps) => {
  const theme = useTheme();
  const skeletons = [
    <IconPathLoader title={title} text={teaserText} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
    <FlightCardSkeleton elevation={0} />,
  ];

  return (
    <Container maxWidth="lg">
      {skeletons.map((skeleton: any, index: number) => {
        return (
          <CustomAnimation
            timeout={1000}
            delay={index * 150 + 1}
            delayOut={1}
            in={true}
            type="fade"
            easing={theme.transitions.easing.easeInOut}
            key={`transition-${index}`}
          >
            <Box key={`flightcard-${index}`}>{skeleton}</Box>
          </CustomAnimation>
        );
      })}
    </Container>
  );
};
